// extracted by mini-css-extract-plugin
export default {"NavLink":"Navigation_NavLink__udcy1","HeaderNav":"Navigation_HeaderNav__79sEC"};